import { useCallback } from 'react';

/** Remove global loader set up in index.html on initial page load **/
export const useRemoveGlobalLoader = () => {
  return useCallback(() => {
    const loader = document.getElementById('global-loader');
    loader?.remove();
  }, []);
};
